import { useCallback, useState } from 'react';
import {
  createVehiculo,
  deactivateVehiculo,
  fetchVehiculo,
  fetchVehiculos,
  updateVehiculo,
} from '../services/flota.service.js';

export function useFlota() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSuccess = message => {
    setSuccess(message);
    setTimeout(() => setSuccess(null), 4000);
  };

  const list = useCallback(async (filters = {}) => {
    setLoading(true);
    setError(null);
    try {
      return await fetchVehiculos(filters);
    } catch (err) {
      setError(err.message || 'No se pudo obtener el listado.');
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  const getById = useCallback(async id => {
    setLoading(true);
    setError(null);
    try {
      return await fetchVehiculo(id);
    } catch (err) {
      setError(err.message || 'No se pudo obtener el vehículo.');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (input, options = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await createVehiculo(input);
      handleSuccess('Vehículo creado correctamente.');
      return result;
    } catch (err) {
      if (!options.throwOnError) {
        setError(err.message || 'No se pudo crear el vehículo.');
        return null;
      }
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const update = useCallback(async (id, input, options = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await updateVehiculo(id, input);
      handleSuccess('Vehículo actualizado correctamente.');
      return result;
    } catch (err) {
      if (!options.throwOnError) {
        setError(err.message || 'No se pudo actualizar el vehículo.');
        return null;
      }
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const deactivate = useCallback(async (id, options = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await deactivateVehiculo(id);
      handleSuccess('Vehículo desactivado.');
      return result;
    } catch (err) {
      if (!options.throwOnError) {
        setError(err.message || 'No se pudo desactivar el vehículo.');
        return null;
      }
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    success,
    list,
    getById,
    create,
    update,
    deactivate,
  };
}
